import { render, staticRenderFns } from "./payment-modal-create.vue?vue&type=template&id=497fc060&scoped=true"
import script from "./payment-modal-create.vue?vue&type=script&lang=js"
export * from "./payment-modal-create.vue?vue&type=script&lang=js"
import style0 from "./payment-modal-create.vue?vue&type=style&index=0&id=497fc060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497fc060",
  null
  
)

export default component.exports